import { optionsFull_search_noResults } from '../../strings.locstring.json';
import { optionsFull_searchPlaceholder } from './FullOptionSearch.locstring.json';
import loc from 'owa-localize';
import { setSearchTerm, getSearchResults, getQuery } from 'owa-options-search';
import { observer } from 'mobx-react';
import { SearchBox, ISearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { FocusZone, FocusZoneDirection, IFocusZone } from 'office-ui-fabric-react/lib/FocusZone';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import OptionSearchSuggestion from './OptionSearchSuggestion';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';

const styles = require('./OptionsFull.scss');

@observer
export default class FullOptionSearch extends React.Component<{}, {}> {
    private searchBoxElement: HTMLInputElement;
    private searchBox: ISearchBox;
    private suggestionFocusZone: IFocusZone;

    render() {
        let suggestedOptions = getSearchResults();
        let showSuggestions = suggestedOptions && suggestedOptions.length > 0;

        return (
            <div onKeyDown={showSuggestions ? this.onSearchBoxKeyDown : undefined}>
                <SearchBox
                    componentRef={this.searchBoxRef}
                    labelText={loc(optionsFull_searchPlaceholder)}
                    title={loc(optionsFull_searchPlaceholder)}
                    className={styles.searchBox}
                    value={getQuery()}
                    onChange={setSearchTerm}
                />
                {getQuery().trim().length > 0 && (
                    <Callout
                        target={this.searchBoxElement}
                        isBeakVisible={false}
                        className={styles.suggestionCallout}>
                        {showSuggestions ? (
                            <FocusZone
                                direction={FocusZoneDirection.vertical}
                                componentRef={this.suggestionFocusZoneRef}>
                                {suggestedOptions.map((option, index) => (
                                    <OptionSearchSuggestion
                                        key={option.key}
                                        option={option}
                                        onKeyDown={this.onFirstOptionKeyDown}
                                        data-option-index={index}
                                    />
                                ))}
                            </FocusZone>
                        ) : (
                            <CommandButton
                                className={styles.noSuggestions}
                                disabled={true}
                                text={loc(optionsFull_search_noResults)}
                            />
                        )}
                    </Callout>
                )}
            </div>
        );
    }

    private onSearchBoxKeyDown = (ev: React.KeyboardEvent<HTMLDivElement>) => {
        if (ev.key === 'ArrowDown') {
            this.suggestionFocusZone.focus();
            ev.stopPropagation();
            ev.preventDefault();
        }
    };

    private onFirstOptionKeyDown = (ev: React.KeyboardEvent<HTMLButtonElement>) => {
        switch (ev.key) {
            case 'ArrowUp':
                if (ev.currentTarget.dataset.optionIndex === '0') {
                    this.searchBox.focus();
                    break;
                } else {
                    return;
                }
            case 'Escape':
                setSearchTerm(null, '');
                this.searchBox.focus();
                break;
            default:
                // don't stop propagation or prevent default
                return;
        }

        ev.stopPropagation();
        ev.preventDefault();
    };

    private searchBoxRef = (ref: ISearchBox) => {
        this.searchBox = ref;
        this.searchBoxElement = ReactDOM.findDOMNode(ref as any) as HTMLInputElement;
    };

    private suggestionFocusZoneRef = (ref: IFocusZone) => {
        this.suggestionFocusZone = ref;
    };
}
